import React, { useState } from 'react'; 
import { RadioButton } from '@progress/kendo-react-inputs';
import FinancingTypeTooltip from './FinancingTypeTooltip';
 
const RdoFinancingType = (props) => {

    const{name, onChange, leftValue, rightValue,label, checkedValue, disabled,leftValueLabel,rightValueLabel, enableTooltip} = props;
    const handleChange = React.useCallback(
        (e) => {
            props.onChange(e,name);
        },
        [onChange,checkedValue]
    )

    const [showTooltip, setShowTooltip] = useState(false);

    const handleOnCloseClick = () => {
        setShowTooltip(false);
    }

    return (
        <div>
            <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                <div className="box text-left greySboxTxtPaddingG">{label}&nbsp;&nbsp;
                {enableTooltip &&
                <span className="k-icon k-i-information" style={{color:'#505050'}} 
                    onClick={()=>{
                        setShowTooltip(true);
                    }}
                />}
                </div>
               
            </div>
      
            <div className=" col-xs-12 col-sm-7 col-md-7 col-lg-7">
                <div style={{width:'50%', float:'left'}}>
                    <RadioButton id={name} name={name} value={leftValue} onChange={handleChange} checked={checkedValue === leftValue} disabled={disabled} >&nbsp;{leftValueLabel}</RadioButton>
                </div>
                <div style={{width:'50%', float:'left'}}>
                    <RadioButton id={name} name={name} value={rightValue} onChange={handleChange} checked={checkedValue === rightValue} disabled={disabled} >&nbsp;{rightValueLabel}</RadioButton>
                </div>
            </div>
        </div>  
        {enableTooltip && 
        <FinancingTypeTooltip popupValue={showTooltip} setPopupValue={setShowTooltip} 
            OnCloseClick={handleOnCloseClick} />
        }
        </div>
    )
}

export default RdoFinancingType;